import { render } from "./forgotpassword.vue?vue&type=template&id=2eec5802&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"

import "./forgotpassword.vue?vue&type=style&index=0&id=2eec5802&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eec5802"]])

export default __exports__